import cx from 'classnames'
import NextLegacyImage from 'next/legacy/image'

import { type SanityFrameBuilderImage } from '@frame-builder/data/sanity/queries/types/image'
import { getImageDimensions, sanityImageLoader } from '@frame-builder/lib/image'

interface PhotoProps {
  image: SanityFrameBuilderImage
  className?: string
}

const Photo = ({ image, className }: PhotoProps) => {
  if (!image?.asset) {
    return null
  }

  const source = JSON.stringify(image)
  const dimensions = getImageDimensions(image)

  return (
    <figure className={cx(className, 'photo')}>
      <NextLegacyImage
        src={source}
        loader={sanityImageLoader}
        width={dimensions?.width}
        height={dimensions?.height}
        alt={image.alt ?? ''}
        className="block overflow-hidden"
      />
    </figure>
  )
}

export default Photo
